import React from 'react'

import { DynamicTitle } from '../../common/DynamicTitle'
import { BoldTextParts } from '../../common/BoldTextParts'
import { AdaptiveCarousel } from '../../common/AdaptiveCarousel'
import { Voucher } from '../../ui/Voucher'
import { useClubContext } from '../../../contexts/ClubContext'
import useWindowDimensions from '../../../hooks/useWindowDimensions'

import type { Vouchers as VouchersProps } from '../../../types/ClubCard/ClubCardUser'

import './vouchers.scss'

export function Vouchers({ visibility, title, text, voucher }: VouchersProps) {
  const { userInfos } = useClubContext()
  const { isMobile } = useWindowDimensions()

  if (!visibility || !userInfos?.couponCartonist) {
    return null
  }

  const vouchers = userInfos.couponCartonist.split('|')

  return (
    <div id="vouchers" className="club-card-user-vouchers grid-content">
      <DynamicTitle className="vouchers-title" title={title} titleLevel={2} />
      <BoldTextParts className="vouchers-subtitle" text={text} />

      <AdaptiveCarousel
        quantity={vouchers.length}
        quantityToCarousel={8}
        activeBlur={false}
        forceCarousel={!!isMobile && vouchers.length > 2}
        propsCarousel={{ gapItems: 0, itemWidthProp: 156 }}
      >
        {vouchers.map((voucherValue) => (
          <Voucher
            key={voucherValue}
            {...voucher}
            voucherValue={voucherValue}
          />
        ))}
      </AdaptiveCarousel>
    </div>
  )
}
